import { memo } from 'react';
import classNames from 'classnames';
import { ITabSelectProps } from './TabSelect.types';
import styles from './styles.module.scss';

export const TabSelect = memo<ITabSelectProps>(({ title, onClick, isSelected }) => (
  <div
    role="button"
    tabIndex={0}
    onKeyDown={() => null}
    onClick={onClick}
    className={classNames({ [styles.container]: true, [styles.selected]: isSelected })}
  >
    <span>{title}</span>
  </div>
));

TabSelect.displayName = 'TabSelect';

export default TabSelect;
